import { Component, ErrorInfo, ReactNode } from "react";
import { Link } from 'react-router-dom';
import Layout from './Layout';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  info?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: true,
      error: error,
      info: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Layout>
          <div className="grid gap-4 justify-content-center justify-items-center content-center">
            <h1 className="text-5xl font-bold -mb-2">Permission Denied</h1>
            <p className="text-xl">
              <p>{this.state.error?.message}</p>
            </p>
            <Link to="/" className="text-blue-500 hover:underline" onClick={() => window.location.href = '/'}>
              Go back home
            </Link>
          </div>
        </Layout>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
